import { gql } from '@zenbusiness/application-commons-graphql';

export const messages = {
  labels: {
    subDomain: 'Sub domain',
    connectedTo: 'Connected domains',
    createSite: 'Build your site',
    switchTemplate: 'Switch Template',
    connectDomain: 'Connect Domain',
    anotherDomain: 'Connect another domain',
    editSite: 'Edit Site',
    internalDomain: 'ZenBusiness domain',
    externalDomain: 'Domain from elsewhere',
    connectionPending: 'Connection pending',
    pending: 'Pending',
    notPublished: 'Not published',
    titleNewWebsitePublished: 'Your new site is available!',
    titleNewWebsiteUnpublished: 'Build an even better website',
    contentNewWebsite: `Your new site is built with our new website
     builder and  has lots of cool new features, like fast site speeds,
     SEO, custom templates and widgets, a full image library,
     lead generation, and marketing material templates.`,
    mobileButtonDisabled: 'Available on desktop only'
  }
};

export const tooltipContent = {
  PUBLISHED: {
    IN_PROGRESS: `This is your current site, which you can’t access during our migration.
      You will be able to edit your site again soon. Or you can choose another template from our new website builder.`,
    MIGRATED: `This is your current site. You can continue to use it or you can create a new website using our improved website builder,
      which has more than 100 new templates and industry-leading features built right in.
      You can start a new website by choosing a template above.`,
    COMPLETE: `This is your current site. You can continue to use it or you can create a new website using our improved website builder,
      which has more than 100 new templates and industry-leading features built right in.
      You can start a new website by choosing a template above.`
  },
  UNPUBLISHED: {
    IN_PROGRESS: `This is your existing template. It’s only available in preview mode.
      To choose a new template and and start migrating your content, click Build your site.`,
    MIGRATED: `This is your legacy site. You can access it until August 1, 2022. After that date it will
      no longer be available. Select from one of the more than 100 new templates today to begin
      migrating your content.`,
    COMPLETE: ''
  }
};

export const GET_WEBSITES_QUERY = gql`
  query WebsitesQuery($businessEntityUuid: UUID!) {
    websites(businessEntityUuid: $businessEntityUuid) {
      websites {
        websiteUuid
        websiteUrl
        active
        zenbusinessDns
        deleted
        googleAnalyticsTrackingId
        dudaActive
        previewUrl
        publishStatus
        certificateStatus
        category
        migrationStatus
        websiteType
      }
    }
    domains(businessEntityUuid: $businessEntityUuid) {
      domains {
        domainUuid
        websiteUuid
        domainName
        active
        configured
        transferred
        expired
        verified
        srsExpireDatetime
        isExternal
        websiteConnectionStatus
        deleted
      }
    }
    businessEntity(businessEntityUuid: $businessEntityUuid) {
      uuid
      name
    }
    orderTasksLegacy(businessEntityUuid: $businessEntityUuid) {
      orderTasksLegacy {
        orderTaskUuid
        orderTaskType
        orderTaskStatus
        orderTaskData {
          ...on DomainNameData {
            skip
          }
        }
      }
    }
    accountInfo {
      accountUuid
      pricing(businessEntityUuid: $businessEntityUuid) {
        service
        amount
        interval
      }
    }
  }
`;

export const GET_WEBSITE_LINK_QUERY = gql`
  query WebsiteLink($websiteUuid: UUID!, $websiteType: String!) {
    websiteLogin(websiteUuid: $websiteUuid, websiteType: $websiteType) {
      websiteUuid
      ssoLink
    }
  }
`;

export const DELETE_WEBSITE_MUTATION = gql`
  mutation DeleteWebsite($websiteUuid: UUID!, $websiteType: String!) {
    deleteWebsite(websiteUuid: $websiteUuid, websiteType: $websiteType)
  }
`;

// Website event data tracking default values
export const WEBSITE_DATA_TRACKING = {
  screenName: 'marketing_tools_website',
  pageCategory: 'dashboard',
  pageSection: 'growth',
  pageTitle: 'Website' /* TODO: Remove me when clickstream migration has been completed */
};

export const LD_RELEASE_TRY_BEFORE_YOU_BUY = 'release-website-builder-try-before-you-buy';
export const LD_ENABLE_E_COMMERCE_EDITOR_SELECTOR = 'enable-e-commerce-editor-selector';
